import React from 'react';
import { TextField, InputAdornment, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ onSearchChange }) => {
    const theme = useTheme();

    const handleChange = (event) => {
        onSearchChange(event.target.value);
    };

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <TextField
                fullWidth
                placeholder="Search projects..."
                onChange={handleChange}
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 2,
                    '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                            borderColor: theme.palette.primary.main,
                        },
                    },
                }}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon sx={{ color: theme.palette.grey[500] }} />
                            </InputAdornment>
                        ),
                    },
                }}
            />
        </Box>
    );
};

export default SearchBar;
